var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUpSmallOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8.363V14a1 1 0 002 0V8.363l1.344 1.344a1 1 0 001.414-1.414l-3.039-3.04a.997.997 0 00-1.438 0l-3.039 3.04a1 1 0 001.414 1.414L9 8.363z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljk5OTk5IDguMzYzVjE0QzguOTk5OTkgMTQuNTUyIDkuNDQ3OTkgMTUgOS45OTk5OSAxNUMxMC41NTIgMTUgMTEgMTQuNTUyIDExIDE0VjguMzYzTDEyLjM0NCA5LjcwN0MxMi43MzQgMTAuMDk3IDEzLjM2OCAxMC4wOTcgMTMuNzU4IDkuNzA3QzE0LjE0OCA5LjMxNiAxNC4xNDggOC42ODMgMTMuNzU4IDguMjkzTDEwLjcxOSA1LjI1MzAxQzEwLjcxNSA1LjI1IDEwLjcxMSA1LjI0NiAxMC43MDcgNS4yNDJDMTAuNTEyIDUuMDQ3IDEwLjI1NiA0Ljk0OTAxIDkuOTk5OTkgNC45NDkwMUM5Ljc0Mzk5IDQuOTQ5MDEgOS40ODc5OSA1LjA0NyA5LjI5Mjk5IDUuMjQyQzkuMjg4OTkgNS4yNDYgOS4yODQ5OSA1LjI1IDkuMjgwOTkgNS4yNTMwMUw2LjI0MTk5IDguMjkzQzUuODUxOTkgOC42ODMgNS44NTE5OSA5LjMxNiA2LjI0MTk5IDkuNzA3QzYuNjMxOTkgMTAuMDk3IDcuMjY1OTkgMTAuMDk3IDcuNjU1OTkgOS43MDdMOC45OTk5OSA4LjM2M1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgArrowUpSmallOutline20 as ReactComponent };